export const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const FIREBASE_TOKEN_KEY = 'firebase-token';

export const DEFAULT_PASSWORD = 'addmile123';

export const DAYS_14 = 14;
